import React from "react";
import { connectHits } from "react-instantsearch-dom";
import { BasicDoc, Hit } from "react-instantsearch-core";
import { Box } from "@mui/material";
import HitsGrid from "./../hits/hits-grid";
import HitsRows from "./../hits/hits-rows";

const SearchHits: React.FunctionComponent<any> = (props: { hits: Hit<BasicDoc>[]; mode?: string | undefined; page?: number }): JSX.Element => {
  const { hits, page } = props;
  return (
    <>
      {page && page > 1 ? (
        <HitsRows hits={hits} />
      ) : (
        <>
          <Box pt="2rem">
            <HitsGrid hits={hits.slice(0, 3)} />
          </Box>
          <Box pt="4rem">
            <HitsRows hits={hits.slice(3, hits.length)} />
          </Box>
        </>
      )}
    </>
  );
};

export default connectHits(SearchHits);
